import { render } from "./v-card.vue?vue&type=template&id=6c391fc6&scoped=true"
import script from "./v-card.vue?vue&type=script&lang=js"
export * from "./v-card.vue?vue&type=script&lang=js"

import "./v-card.vue?vue&type=style&index=0&id=6c391fc6&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c391fc6"]])

export default __exports__